import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { EmptyThumbnails } from '../ListTilePlaceholder';

const ListImages = ({ images, itemCount, numberOfThumbnails, url, disableThumbnailsLink = false }) => {
  if (itemCount <= 0 || !images || images.length === 0) {
    return <EmptyThumbnails numberOfThumbnails={numberOfThumbnails + 1} />;
  }

  const renderImage = (image, index) => {
    const imgElement = (
      <img
        key={`list-image-${index}`}
        src={image.url}
        alt={`List item ${index + 1}`}
        width="auto"
        height="auto"
        className="sui-w-14 @sm:sui-w-20 @xl:sui-w-24 sui-aspect-square sui-object-cover"
        data-testid={`list-image-${index}`}
      />
    );

    return !disableThumbnailsLink && url ? (
      <Link key={`list-image-link-${index}`} href={url}>
        {imgElement}
      </Link>
    ) : (
      imgElement
    );
  };

  return (
    <div className="sui-flex sui-flex-nowrap sui-gap-2 sui-overflow-x-hidden">
      {images.slice(0, numberOfThumbnails).map((image, index) => renderImage(image, index))}
      {itemCount > numberOfThumbnails && (
        <div
          className="sui-w-14 @sm:sui-w-20 @xl:sui-w-24 sui-aspect-square sui-grid
          sui-place-items-center sui-bg-strong"
          data-testid="list-image-more"
        >
          <Typography>+{itemCount - numberOfThumbnails}</Typography>
        </div>
      )}
    </div>
  );
};

ListImages.propTypes = {
  itemCount: PropTypes.number.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string
  })),
  numberOfThumbnails: PropTypes.number.isRequired,
  url: PropTypes.string,
  disableThumbnailsLink: PropTypes.bool
};

export default ListImages;